import createField from './createField';
import plain from './structure/plain';

export default createField(plain);


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-form/es/Field.js
// module id = 1235
// module chunks = 0